export default __webpack_public_path__ + "static/media/close-blue.e75f91da.svg";